"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    router.replace("/studio");
  }, [router]);

  return <main className="grid min-h-screen place-items-center text-sm text-[var(--muted-foreground)]">화면을 여는 중...</main>;
}
